/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { getShadowElement } from '@tylertech/forge-core';
import { BaseAdapter } from '../../core/base/base-adapter';
import { isFocusable, setDefaultAria } from '../../constants';
import { STATE_LAYER_CONSTANTS } from '../../state-layer/state-layer-constants';
import { FOCUS_INDICATOR_CONSTANTS } from '../../focus-indicator/focus-indicator-constants';
export class ButtonToggleAdapter extends BaseAdapter {
    constructor(component) {
        super(component);
        this._focusIndicatorElement = getShadowElement(component, FOCUS_INDICATOR_CONSTANTS.elementName);
        this._stateLayerElement = getShadowElement(component, STATE_LAYER_CONSTANTS.elementName);
    }
    initialize() {
        this._component[setDefaultAria]({ role: 'button' }, { setAttribute: !this._component.hasAttribute('role') });
        this._component[setDefaultAria]({
            ariaPressed: `${!!this._component.selected}`,
            ariaDisabled: `${!!this._component.disabled}`
        });
        this._component[isFocusable] = !this._component.disabled;
    }
    setSelected(value) {
        this._component[setDefaultAria]({ ariaPressed: `${!!value}` });
    }
    setDisabled(value) {
        this._component[setDefaultAria]({ ariaDisabled: `${!!value}` });
        this._component[isFocusable] = !value;
        this._stateLayerElement.disabled = value;
    }
    forceFocusVisible() {
        this._focusIndicatorElement.active = true;
    }
}
